import { render } from "./index.vue?vue&type=template&id=22299e68&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=22299e68&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22299e68"]])

export default __exports__